import React, { useContext, useEffect, useState } from "react";
import {
  Menu,
  MenuItemLink,
  useResourceDefinitions,
  useSidebarState,
} from "react-admin";
import MenuContextMerchant from "./MenuContextMerchant";
import { Collapse, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box, Divider } from "@mui/material";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { merchantContext } from "../../../../DataProvider";
import Help from "./Help";
import HelpCircle from "./HelpCircle";

const MenuCustom = (props) => {
  const resourcesDefinitions = useResourceDefinitions();
  const resources = Object.keys(resourcesDefinitions).map(
    (name) => resourcesDefinitions[name]
  );
  const element_change = [
    {
        name : 'socios',
        destURL:`${process.env.REACT_APP_REDIRECT}/socios`
    },
    {
      name : 'planes',
      destURL : `${process.env.REACT_APP_REDIRECT}/planes`
    },
    {
      name: 'busqueda',
      destURL: `${process.env.REACT_APP_REDIRECT}/busqueda`
    },
    {
      name: 'accesos',
      destURL: `${process.env.REACT_APP_REDIRECT}/accesos`
    },
    {
      name: 'corporativo',
      destURL: `${process.env.REACT_APP_REDIRECT}/corporativo`
    }
  ];
  const filteredResources = resources
    .filter((item) => !item?.options?.hidden)
    .map((item) => {
      const els = element_change.find((changeItem) => changeItem.name === item.name);
      return els
        ? { ...item, options: { ...item.options, destURL: els.destURL } }
        : { ...item, options: { ...item.options } }
    });
  const sidebarOpen = useSidebarState();
  const handleChange = () => sidebarOpen[1](window.innerWidth > 600);

  useEffect(() => {
    handleChange();
    window.addEventListener("resize", handleChange);
    return () => window.removeEventListener("resize", handleChange);
  }, []);

  return (
    <Menu
      {...props}
      sx={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      <MenuContextMerchant />
      <Divider style={{ margin: "3px 18px 15px 18px" }} />
      <Box
        id="scrollableDivJoyRide"
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: "5px",
            borderRadius: "12px",
          },
        }}
      >
        {filteredResources.map((resource, index) => {
          if (resource.options?.isMenuParent) {
            return (
              <>
                <SectionParent
                  id={index}
                  resource={resource}
                  resources={filteredResources}
                />
              </>
            );
          } else {
            if (resource.hasList && !resource.options?.menuParent) {
              return (
                <>
                  <MenuItemLink
                    id="dashboard"
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={
                      (resource.options && resource.options.label) ||
                      resource.name
                    }
                    leftIcon={resource.icon ? <resource.icon /> : null}
                    sidebarIsOpen={open}
                    style={{
                      color: grey[600],
                      padding: "6px 16px",
                      margin: sidebarOpen[0] ? "0 12px" : "3px",
                      fontWeight: "600",
                      borderRadius: "12px",
                      fontSize: "0.85rem",
                      lineHeight: "1.75",
                      letterSpacing: "0.01em",
                    }}
                  />
                </>
              );
            }
          }
        })}
      </Box>
      <Divider style={{ margin: "5px 0" }} />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{
          width: "100%",
          flexShrink: 0,
          padding: "8px 0",
        }}
      >
        {sidebarOpen[0] ? (
          <Help />
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{
              width: "100%",
            }}
          >
            <HelpCircle />
          </Box>
        )}
      </Box>
    </Menu>
  );
};

const SectionParent = ({ resource, resources }) => {
  //Llamo al context de Merchant
  const { getMerchant } = useContext(merchantContext);
  const merchantSelected = getMerchant();

  const [open, setOpen] = useState(true);
  const sidebarOpen = useSidebarState();
  const [buttonClicked, setButtonClicked] = useState(false);

  return (
    <Box
      style={{
        marginBottom: open && "6px",
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "0px 12px",
          padding: "9px 9px 9px 15px",
          cursor: "pointer",
          borderRadius: "12px",
          // '&:hover': {
          //   backgroundColor: grey[200]
          // }
        }}
        onClick={() => setOpen(!open)}
      >
        {sidebarOpen[0] && (
          <>
            <Typography
              variant="subtitle2"
              style={{
                color: grey[600],
                letterSpacing: "0.05em",
                fontFamily: "Raleway, sans-serif",
                fontWeight: "500",
                fontSize: "0.78rem",
              }}
            >
              {resource.name}
            </Typography>
            {open ? (
              <MdExpandLess style={{ color: grey[600] }} />
            ) : (
              <MdExpandMore style={{ color: grey[600] }} />
            )}
          </>
        )}
      </Box>
      <Collapse in={!sidebarOpen[0] || open} unmountOnExit>
        {resources.map((item) => {
          if (
            item.options?.menuParent &&
            item.options?.menuParent === resource.name
          ) {
            // //re dirrecion de planes si se necesiita
            // if (
            //   item.name == "planes" &&
            //   item.options.menuParent == "ADMINISTRATIVO"
            // ) {
            //   return (
            //     <div onClick={() => { setButtonClicked(true) }}>
            //       <MenuItemLink
            //         className={item?.name}
            //         key={item.name}
            //         to={`/${item.name}`}
            //         primaryText={
            //           (item.options && item.options.label) || item.name
            //         }
            //         leftIcon={item.icon ? <item.icon /> : null}
            //         sidebarIsOpen={open}
            //         style={{
            //           margin: sidebarOpen[0] ? "0px 12px 0 24px" : "0px 3px",
            //           color: grey[600],
            //           padding: "6px 16px",
            //           fontWeight: "600",
            //           borderRadius: "12px",
            //           fontSize: "0.85rem",
            //           lineHeight: "1.75",
            //           letterSpacing: "0.01em",
            //           "&.active": {
            //             backgroundColor: grey[200],
            //             color: "#5584AC",
            //             "& .MuiListItemIcon-root": {
            //               color: "#5584AC",
            //             },
            //           },
            //         }}
            //       />
            //     </div>
            //   );
            // }
            const isExternal = Boolean(item.options?.destURL);
            return (
              <MenuItemLink
                key={item.name}
                className={item.name}
                to={isExternal ? "#" : `/${item.name}`}
                onClick={(ev) => {
                  if (!isExternal) return;

                  ev.preventDefault();
                  ev.stopPropagation();

                  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
                  const token = auth.token;
                  const merchant = localStorage.getItem("merchant");
                  const permissions =
                    localStorage.getItem("permissions");

                  window.location.assign(
                    `${item.options.destURL}?token=${token}&permissions=${permissions}&merchant=${merchant}`
                  );
                }}
                primaryText={(item.options && item.options.label) || item.name}
                leftIcon={item.icon ? <item.icon /> : null}
                sidebarIsOpen={open}
                sx={{
                  margin: sidebarOpen[0] ? "0px 12px 0 24px" : "0px 3px",
                  color: grey[600],
                  padding: "6px 16px",
                  fontWeight: "600",
                  borderRadius: "12px",
                  fontSize: "0.85rem",
                  lineHeight: "1.75",
                  letterSpacing: "0.01em",
                  "&.active": {
                    backgroundColor: grey[200],
                    color: "#5584AC",
                    "& .MuiListItemIcon-root": {
                      color: "#5584AC",
                    },
                  },
                }}
              />
            );
          }
        })}
      </Collapse>
    </Box>
  );
};

export default MenuCustom;